import {
  advertisedStates,
  defaultState,
  type StateConfig,
} from "@/lib/states-config";

export interface StateListItem {
  state: StateConfig;
  showSeparator: boolean;
}

export const stateListItems: readonly StateListItem[] = [
  ...advertisedStates.map((state) => ({ state, showSeparator: false })),
  { state: defaultState, showSeparator: true },
];
